export const throwError = (message: string, module: string) => {
  console.warn(`${module}: ${message}`);
  throw new Error(`${module}: ${message}`);
};
